/**
 * Check if an error is a 403 Forbidden error
 */
export const is403Error = (error: any): boolean => {
  if (!error) return false;

  // Check error object structure
  const errorMessage =
    error?.results?.error ||
    error?.error ||
    (error instanceof Error ? error.message : String(error));

  return errorMessage.includes('403') || errorMessage.toLowerCase().includes('forbidden');
};

/**
 * Get appropriate error message for FUB API errors
 */
export const getFubErrorMessage = (error: any, defaultMessage: string): string => {
  if (is403Error(error)) {
    return 'API key has permissions issue. Please secure the Owner API Key.';
  }

  // Return custom error message if available
  if (error instanceof Error) {
    return error.message;
  }

  if (error?.message) {
    return error.message;
  }

  return defaultMessage;
};
